module.exports = __webpack_public_path__ + "dist/img/Claire.2d02ff97.png";